import FavoritesWithDataView from "./FavoritesWithDataView";

export default FavoritesWithDataView;
